import { createChatsSlice, chatsInitialState } from '@sv-support-sdk/store';

const chats = createChatsSlice({
  name: 'chats',
  initialState: { ...chatsInitialState },
  reducers: {},
});

export const chatsActions = chats.actions;

export default chats.reducer;
